import React from "react";
import { Tooltip } from "@/components/common/Tooltip";

export interface SelectionButtonProps {
  isSelected: boolean;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  children: React.ReactNode;
  tooltip?: string;
  /// Set when the button toggles a selection a screen reader can't infer from
  /// the tint alone (a pick-one list, not a nav item that also looks active).
  ariaPressed?: boolean;
}

const getSelectionClass = (isSelected: boolean) =>
  isSelected ? "bg-list-selected-light" : "hover:bg-list-hover";

export function SelectionButton({
  isSelected,
  onClick,
  className = "",
  children,
  tooltip,
  ariaPressed,
}: SelectionButtonProps) {
  const button = (
    <button
      onClick={onClick}
      aria-pressed={ariaPressed}
      className={`px-2 py-1 item-height rounded-app ${className} ${getSelectionClass(isSelected)}`}
    >
      {children}
    </button>
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
}
